"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updatePrintable;
const Printable_1 = require("../../models/printables/Printable");
const either_1 = require("../../types/either");
const updateSurface_1 = require("./updateSurface");
const updateDesign_1 = require("./updateDesign");
const updateLayers_1 = require("./updateLayers");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
function updatePrintable(_ref) {
  let {
    sku,
    printable,
    timestamp,
    designId,
    rotateWorkspace: printableRotatedInWorkspace,
    newTemplate,
    oldTemplate,
    printableGroupType,
    interiorPageCount,
    hammerCategory,
    ignoreEditableTextTemplateLayers
  } = _ref;
  const nextPrintable = (0, Printable_1.updatePrintableVersion)(printable, timestamp);
  const newPrintable = Object.assign(Object.assign({}, nextPrintable), {
    surface: (0, updateSurface_1.updateSurface)({
      printable: (0, lodash_clonedeep_1.default)(nextPrintable),
      newTemplate,
      interiorPageCount,
      printableGroupType
    })
  });
  const updateDesignResult = (0, updateDesign_1.updateDesign)({
    printable: newPrintable,
    oldTemplate,
    newTemplate,
    designId,
    interiorPageCount,
    hammerCategory,
    printableGroupType
  });
  if (updateDesignResult.isLeft()) {
    return (0, either_1.left)(updateDesignResult.value);
  }
  const {
    leftDesign,
    rightDesign
  } = updateDesignResult.value;
  const updateLayersResult = (0, updateLayers_1.updateLayers)({
    sku,
    printable: newPrintable,
    printableRotatedInWorkspace,
    oldSurface: printable.surface,
    newSurface: newPrintable.surface,
    newTemplate,
    leftDesign,
    rightDesign,
    printableGroupType,
    ignoreEditableTextTemplateLayers
  });
  if (updateLayersResult.isLeft()) {
    return (0, either_1.left)(updateLayersResult.value);
  }
  return (0, either_1.right)(newPrintable);
}